import React, { Component } from 'react'

export default class Step1 extends Component {
    render() {
        return (
            <div>
                <h2>Let's talk about your idea</h2>
                <p>Answer a few quick questions and we will help you get feedback from relevant investors and industry experts.</p>
                <br/>
            </div>
        )
    }
}
